export default "__VITE_PUBLIC_ASSET__bdf3b97c__"